import PropTypes from 'prop-types';
import { Avatar, Box, Button, Card, CardActions, Divider, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { ArrowRight as ArrowRightIcon } from '../../../icons/arrow-right';
import { ChevronDown as ChevronDownIcon } from '../../../icons/chevron-down';
import { Chart } from '../../chart';
import { useEffect, useState } from 'react';

export const OportunidadesVentasUnidades = (props) => {
  const { oportunidades = [], date = new Date() } = props;
  const [total, setTotal] = useState(0);
  const [totalCompleted, setTotalCompleted] = useState(0);
  const [porcentajeTotal, setPorcentajeTotal] = useState(0);
  const [porcentajeTotalCompleted, setPorcentajeTotalCompleted] = useState(0);
  const theme = useTheme();

  // Dentro de oportunidades.vehiculos recorrer cada vehiculo y sumar el vehiculo.quantity
  const sumarTotal = () => {
    let total = 0;
    oportunidades.forEach(oportunidad => {
      oportunidad.vehiculos.forEach(vehiculo => {
        // El numero es un string, convertirlo a numero
        // Solo sumar si el estatus es diferente de "cancelled"
        if (oportunidad.status !== 'cancelled') {
          total += parseInt(vehiculo.quantity);
        }
      });
    });
    setTotal(total);

    let totalCompleted = 0;
    // Sumar los que tienen un status de "delivered", "paid" o "deposit"
    oportunidades.forEach(oportunidad => {
      if (oportunidad.status === 'delivered' || oportunidad.status === 'paid' || oportunidad.status === 'deposit') {
        oportunidad.vehiculos.forEach(vehiculo => {
          totalCompleted += parseInt(vehiculo.quantity);
        });
      }
    });
    setTotalCompleted(totalCompleted);

    // Calcular el porcentaje de ventas completadas
    setPorcentajeTotalCompleted((totalCompleted / total) * 100);
    // Calcular el porcentaje de ventas en proceso
    setPorcentajeTotal(((total - totalCompleted) / total) * 100);
  }

  useEffect(() => {
    sumarTotal();
  }, [oportunidades]);

  const chartOptions = {
    chart: {
      background: 'transparent',
      stacked: false,
      toolbar: {
        show: false
      }
    },
    colors: [theme.palette.primary.light],
    fill: {
      opacity: 1
    },
    labels: [],
    plotOptions: {
      radialBar: {
        dataLabels: {
          show: false
        },
        hollow: {
          size: '40%'
        },
        track: {
          background: theme.palette.primary.dark
        }
      }
    },
    theme: {
      mode: theme.palette.mode
    }
  };

  return (
    <Card {...props}
      style={{
        marginTop: '10px',
        marginBottom: '10px',
      }}
    >
      <Box
        sx={{
          alignItems: {
            sm: 'center'
          },
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: {
            xs: 'column',
            sm: 'row'
          }
        }}
      >
        <Chart
          height={200}
          options={chartOptions}
          series={[porcentajeTotal]}
          type="radialBar"
          width={200}
        />
        <Box
          sx={{
            display: 'flex',
            flexGrow: 1,
            pt: {
              sm: 3
            },
            pb: 3,
            pr: 4,
            pl: {
              xs: 4,
              sm: 0
            }
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              mr: 3
            }}
          >
            <Typography
              color="primary"
              variant="h3"
            >
              {totalCompleted}
            </Typography>
            <Typography
              color="textSecondary"
              variant="body2"
            >
              Unidades vendidas de
            </Typography>
            {
              // Si total !== totalCompleted
              total !== totalCompleted && (
                <>
                  <Typography
                    color="textSecondary"
                    variant="h6"
                  >
                    {total}
                  </Typography>
                  <Typography
                    color="textSecondary"
                    variant="body2"
                  >
                    unidades esperadas a vender
                  </Typography>
                </>
              )
            }
          </Box>
        </Box>
      </Box>
    </Card>
  );
};

OportunidadesVentasUnidades.propTypes = {
  oportunidades: PropTypes.array.isRequired,
  date: PropTypes.instanceOf(Date).isRequired
};